module.exports = __webpack_public_path__ + "static/media/303ColumnLabel--16.76d07420.svg";